import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "./../../../../environments/environment";

@Component({
  selector: "app-bio-data-basic",
  templateUrl: "./bio-data-basic.component.html",
})
export class BioDataBasicComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}

  loading = false;
  _isApplication = authData("_isApplication");
  payload: StudentBioData = this.initStudentBioData();
  req: StudentBioData = this.initStudentBioData();
  verificationReq: any = {};
  notification = {};
  skeletonLoader = true;
  status: boolean = false;
  verified = false;
  isDisabled = false;
  countries: any = {};
  states: any = {};
  localGovts: any = {};

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  DTOs = {
    Religion: ["NotSet", "Christianity", "Islam", "Other"],
    NameTitle: ["Mr", "Miss", "Mrs", "Dr", "Prof"],
    MaritalStatus: ["Single", "Married", "Divorced", "Widowed"],
    Gender: ["NotSet", "Male", "Female"],
    ChildLeavingWith: []
  };

  ngOnInit(): void {
    const { AlternateEmailVerified, ProgramRequireEmailVerification } =
      authData("_checks");
    if (!ProgramRequireEmailVerification || AlternateEmailVerified) {
      this.verified = true;
    }

    const baseUrl = `${environment.BASE_URL}/${this._isApplication ? 'applications' : 'biodata'}/bioDataDetails`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        this.payload = res.Data || {};
        if (this.payload) {
          this.payload.DateOfBirth = this.payload.DateOfBirth.split('T')[0];
          if (!this._isApplication && !this.payload.AllowedStatus.includes(this.payload.Status)) {
            this.isDisabled = true;
          }
          if (!this.payload.Nationality) this.getCountries();
          this.getStates();
          this.getLocalGovts(this.payload.StateId);
        }
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );

    this.getRelationshipsWithChild();
  }
  formatDate(date: string): string {
    const dateSplit = date.split('-');
    // return `${new Date(parseInt(dateSplit[0]), parseInt(dateSplit[1]), parseInt(dateSplit[2])).toISOString()}`;
    return `${dateSplit[0]}-${dateSplit[1]}-${dateSplit[2]}`;
  }

  updateBiodata() {
    this.loading = true;
    this.notification = {};
    // this.payload.DateOfBirth = new Date(this.payload.DateOfBirthString);
    // this.payload.PreviousSchoolDate = new Date(this.payload.PreviousSchoolDateString);

    let baseUrl;
    baseUrl = `${environment.BASE_URL}/${this._isApplication ? 'applications' : 'biodata'}/saveBiodata`;
    // if (!this.isDisabled) {
    //   baseUrl = `${environment.BASE_URL}/biodata/saveBiodata`;
    // } else {
    //   baseUrl = `${environment.BASE_URL}/biodata/SaveBioDataByStatus`;
    // }

    this.httpClient.put(baseUrl, this.payload, this.httpOptions).subscribe(
      (res: any) => {
        if (res.Success) {
          this.router.navigateByUrl("/bio-data#Biodata+information+updated");
        }
        else {
          this.loading = false;
          this.notification = {
            error: true,
            message:
              res?.Message || "An error occurred. Please, try again",
          };

        }
      },
      (err) => {
        this.loading = false;
        this.notification = {
          error: true,
          message:
            err?.error?.Message || "An error occurred. Please, try again",
        };
      }
    );
  }

  verifyEmail() {
    this.verificationReq = {
      Email: this.payload?.Email ?? "",
      Url: `${environment.FRONTEND_BASE_URL}/verify`,
    };
    const baseUrl = `${environment.BASE_URL}/biodata/sendverificationmail`;
    this.httpClient.post(baseUrl, this.req, this.httpOptions).subscribe(
      (res) => {
        this.router.navigateByUrl(
          "/bio-data#Email+verification+link+has+been+sent+to+your+email"
        );
      },
      (err) => {
        this.loading = false;
        this.notification = {
          error: true,
          message:
            err?.error?.Message || "An error occurred. Please, try again",
        };
      }
    );
  }

  getRelationshipsWithChild() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/RelationshipsWithChild`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        this.DTOs.ChildLeavingWith = res.Data || [];
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );
  }

  getCountries() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/countries`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        this.countries = res.Data || [];
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );
  }

  getStates() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/states`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        this.states = res.Data || [];
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );
  }

  getLocalGovts(stateId: string) {
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/biodata/localgovt?stateId=${stateId}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.loading = false;
        this.localGovts = res.Data || [];
      },
      (err) => {
        this.loading = false;
      }
    );
  }
  onStateChange() {
    if (this.payload?.StateOfOrigin) {
      this.getLocalGovts(this.payload.StateOfOrigin);
    }
  }

  
  initStudentBioData(): StudentBioData {
    return {
      Surname : "",
      FirstName : "",
      MiddleName : "",
      Religion : "",
      Email : "",
      DateOfBirth : "",
      PlaceOfBirth : "",
      LocalGovernmentArea : "",
      City : "",
      HomeAddress : "",
      HomeTelephone : "",
      Mobile : "",
      Gender : "",
      Programme : "",
      PreviousStudent : false,
      PreviousStudentNo : "",
      OtherInformationAboutChild : "",
      Nationality : "",
      StateOfOrigin : "",
      StateId : "",
      StudentNo : "",
      AppNo : "",
      StudentNoAssigned : "",
      ChildLeavingWith : "",
      StateAddress : "",
      Status : "",
      AllowedStatus: []
    }
  }
}



interface StudentBioData
    {
        Surname : string;
        FirstName : string;
        MiddleName : string;
        Religion : string;
        Email : string;
        DateOfBirth : string;
        PlaceOfBirth : string;
        LocalGovernmentArea : string;
        City : string;
        HomeAddress : string;
        HomeTelephone : string;
        Mobile : string;
        Gender : string;
        Programme : string;
        PreviousStudent : boolean;
        PreviousStudentNo : string;
        OtherInformationAboutChild : string;
        Nationality : string;
        StateOfOrigin : string;
        StateId : string;
        StudentNo : string;
        AppNo : string;
        StudentNoAssigned : string;
        ChildLeavingWith : string;
        StateAddress : string;
        Status : string;
        AllowedStatus: string[];
    }
